import { elementTypePriority } from "../selection/selection.service";

export type MaterialName =
  // Point materials
  | 'PointMaterial'
  | 'PointMaterialRed'
  | 'PointMaterialGreen'
  | 'PointMaterialYellow'
  | 'PointMaterialBlack'
  | 'PointMaterialBlue'
  | 'PointMaterialMagenta'

  // Text and UI elements
  | 'TextMaterial'
  | 'RulerLineMaterial'

  // Inspection materials
  | 'BlueInspectionMaterial'
  | 'GreyInspectionMaterial'
  | 'RedInspectionMaterial'
  | 'YellowInspectionMaterial'
  | 'GreenInspectionMaterial'
  | 'InspectionMaterial'
  | 'OrphanInspectionMaterial'

  // Critical areas
  | 'CriticalAreaMaterial'
  | 'CriticalAreaBoxMaterial'

  // Selection materials
  | 'SelectedBasicMaterial'
  | 'SelectedBasicElementMaterial'
  | 'SelectedAreaInspecMaterial'
  | 'InspectionListElementMaterial'

  // Protection elements
  | 'PaintMaterial'
  | 'AnodeMaterial'
  | 'ProtectionElementsMaterial'
  | 'AnodeHighlightMaterial'
  | 'AnodeLowlightMaterial'
  | 'SensorHighlightMaterial'

  // Anomaly materials
  | 'GreyAnomalyMaterial'
  | 'RedAnomalyMaterial'
  | 'OrangeAnomalyMaterial'
  | 'YellowAnomalyMaterial'
  | 'BlueAnomalyMaterial'
  | 'GreenAnomalyMaterial'

  // Repair materials
  | 'RepairBasicMaterial'
  | 'ExecutedRepairMaterial'
  | 'HatchingMaterial'
  | 'CutPreviewMaterial'
  | 'DoublerExecutedRepairMaterial'

  // 4D structure materials
  | 'Structure4DMaterial'

  // Structure view-mode materials
  | 'AcceptableCorrosionViewModeMaterial'
  | 'SubstantialCorrosionViewModeMaterial'
  | 'ExcessiveCorrosionViewModeMaterial'

  // Basic structure materials
  | 'BasicMaterial'
  | 'BasicPhysicalMaterial'
  | 'LightModelMaterial'
  | 'StainlessSteelMaterial'
  | 'StructureMaterial'
  | 'StiffenerMaterial3d'
  | 'BracketMaterial3d'
  | 'FlangeMaterial3d'
  | 'SensorMaterial'
  | 'SensorXrayMaterial'
  | 'AnomalyGraphicsBasicMaterial'

  // Default for materials not specified
  | 'default'

  // FEA mesh materials
  | 'FeaMeshMaterial'
  | 'FemMaterial';

const SUPPORTED_MATERIALS_LIST = [
  'BlueInspectionMaterial',
  'GreyInspectionMaterial',
  'RedInspectionMaterial',
  'YellowInspectionMaterial',
  'GreenInspectionMaterial',
  'InspectionMaterial',
  'PointMaterial',
  'PointMaterialRed',
  'PointMaterialGreen',
  'PointMaterialYellow',
  'PointMaterialBlack',
  'PointMaterialBlue',
  'PointMaterialMagenta',
  'OrphanInspectionMaterial',
  'AnodeMaterial',
  'ProtectionElementsMaterial',
  'SensorHighlightMaterial',
  'CriticalAreaMaterial',
  'SelectedBasicMaterial',
  'SelectedBasicElementMaterial',
  'SelectedAreaInspecMaterial',
  'HatchingMaterial',
  'FeaMeshMaterial',
  'FemMaterial',
  'Structure4DMaterial'
] as const satisfies readonly MaterialName[];

export type RiskMaterialNamePattern = `RiskMaterial_${string}`;

export type SupportedBringToFrontMaterialName = typeof SUPPORTED_MATERIALS_LIST[number] | RiskMaterialNamePattern;

export const SUPPORTED_BRING_TO_FRONT_MATERIALS: readonly SupportedBringToFrontMaterialName[] = SUPPORTED_MATERIALS_LIST;

export interface MaterialOffset {
  factor: number;
  units: number;
}

export interface MaterialConfig {
  name: MaterialName;
  supportsBringToFront: boolean;
  offset?: MaterialOffset;
}

export type ElementTypeName = typeof elementTypePriority[number];
